import { UseQueryOptions } from '@tanstack/react-query';
import bookingChangesApi from '@/features/dashboard/bookingChanges/api/bookingChangesApi.ts';
import { bookingChangesApiQueryKeys } from '@/features/dashboard/bookingChanges/api/bookingChangesApi.queryKeys.ts';
import { BookingChangeListDto } from '@/features/dashboard/bookingChanges/types/dto/BookingChangeListDto.ts';

/**
 * Komplet paczek rezerwacji — jedno zapytanie, dwóch konsumentów: historia
 * (`useGetChangeHistory`, odsiewa szkice) i numer paczki
 * (`useChangePackageNumber`, liczy po komplecie). Rozdzielenie ich na dwa
 * zapytania rozjechałoby numerację z tym, co pokazuje tabela.
 */
export const getChangesQueryOptions = (
  bookingId: string | undefined,
): UseQueryOptions<BookingChangeListDto[]> => ({
  queryKey: bookingChangesApiQueryKeys.changes(bookingId ?? ''),
  queryFn: () => bookingChangesApi.getChanges(bookingId!),
  enabled: !!bookingId,
  staleTime: 1000 * 60,
});
